/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import ChevronDownIcon from '@offerzen/zenicon/ChevronDownIcon'
import { colors } from '../../themes'
import AccessibleIcon from '../AccessibleIcon'
import MenuIcon from './MenuIcon'
import styles from './styles'

class IconMenu extends Component {
  // eslint-disable-next-line react/state-in-constructor
  state = {
    open: false,
  }

  render() {
    const { open } = this.state
    const { value, onChange, disabled, ...props } = this.props
    const children = React.Children.toArray(props.children)

    const selectedChild = children.find(child => child.props.value === value) || { props: { label: '', icon: '', theme: '' } }
    const isPlaceholder = value === '' && !!children.find(child => child.props.value === '' && child.props.disabled)

    return (
      <div className={styles.wrapper}>
        <div
          className={cx(styles.label, isPlaceholder && styles.labelPlaceholder, open && styles.labelOpen)}
          disabled={disabled}
          tabIndex={disabled ? '-1' : props.tabIndex}
          onClick={() => {
            if (!disabled) this.setState({ open: !open })
          }}>
          {Boolean(selectedChild.props.icon) && <MenuIcon icon={selectedChild.props.icon} theme={selectedChild.props.theme} />}
          <span>{selectedChild.props.label}</span>
          <span className={styles.arrow}>
            <AccessibleIcon icon={ChevronDownIcon} color={colors.grayChateau} size={12} />
          </span>
        </div>
        {Boolean(open) && (
          <>
            <ul className={styles.body}>
              {React.Children.map(children, child =>
                React.cloneElement(child, {
                  selected: child.props.value === value,
                  onClick: () => {
                    if (onChange) onChange(child.props.value)

                    this.setState({ open: false })
                  },
                }),
              )}
            </ul>
            <div className={styles.overlay} onClick={() => this.setState({ open: false })} />
          </>
        )}
      </div>
    )
  }
}
IconMenu.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  tabIndex: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

IconMenu.defaultProps = {
  tabIndex: '0',
}
export default IconMenu
